import React, { Component } from 'react'
import { Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
class EMInput extends Component {

    constructor(...args) {
      super(...args)
      this.state = {}
      
    }

    onFormChange(e) {
        this.props.onChange(e.target.value)
    }

    render() {
        let {formData,schema,required} = this.props
        return(
            <Form>
                <FormGroup>
                    <ControlLabel>{schema.title}{required?<span className='text-red'>*</span>:''}</ControlLabel>
                    <FormControl value={formData} onChange={this.onFormChange.bind(this)} />
                </FormGroup>
            </Form>    
        )
    }    
}    
export default EMInput


// WEBPACK FOOTER //
// ./src/view/hr/employee/EMInput.js